import React from 'react';
import { Form, Row, Col, Dropdown } from 'react-bootstrap';
import styles from '../AddProducts.module.scss';

const CategorySelect = ({
    categories,
    value,
    onChange,
    error,
    edit,
    loading,
    searchType,
    setSearchType,
    searchTerm,
    setSearchTerm
}) => {

    const handleCategorySelect = (categoryId) => {
        const selected = categoryId ? categories.find(cat => String(cat.id) === String(categoryId)) : null;
        onChange({
            target: {
                name: 'selectedCategoryId',
                value: categoryId,
                category: selected ? selected.name : ''
            }
        });
    };

    return (
        <Form.Group as={Row} className='mb-3'>
            <Form.Label column sm={3}>
                Product Category <span className='text-danger'>*</span>
            </Form.Label>
            <Col sm={9}>
                <Dropdown
                    className="w-100"
                    onToggle={(nextShow) => {
                        // When the dropdown closes, clear the parent's search term
                        if (!nextShow && typeof setSearchTerm === 'function') {
                            setSearchTerm('');
                        }
                    }}
                >
                    <Dropdown.Toggle
                        variant='light'
                        className={`form-select text-start ${styles.noCaret} w-100 ${error ? 'is-invalid' : ''}`}
                        id='category-select'
                        disabled={loading}
                    >
                        {(() => {
                            if (value) {
                                const selected = categories.find(cat => String(cat.id) === String(value));
                                return selected ? selected.name : 'Select a Product category';
                            }
                            return 'Select a Product category';
                        })()}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={styles.dropdownMenu}>
                        <div className={styles.searchContainer}>
                            <div className="d-flex gap-2">
                                {setSearchType && (
                                    <Form.Control
                                        size='sm'
                                        as="select"
                                        className='form-select'
                                        value={searchType || 'name'}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setSearchType(val);
                                        }}
                                        style={{ width: 'auto' }}
                                    >
                                        <option value="name">Name</option>
                                    </Form.Control>
                                )}
                                {setSearchTerm && (
                                    <Form.Control
                                        size='sm'
                                        type='text'
                                        placeholder='Search categories...'
                                        value={searchTerm || ''}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setSearchTerm(val);
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                        <div className={styles.scrollableMenu}>
                            {categories.length === 0 && !loading && (
                                <div className={styles.noMatches}>No categories found</div>
                            )}
                            {loading ? (
                                <div className={styles.noMatches}>Loading categories...</div>
                            ) : (
                                <>
                                    {!(searchTerm && String(searchTerm).trim() !== '') && (
                                        <Dropdown.Item
                                            key="none"
                                            active={!value}
                                            onClick={() => handleCategorySelect('')}
                                        >
                                            Select a Product category
                                        </Dropdown.Item>
                                    )}
                                    {categories.map((category) => (
                                        <Dropdown.Item
                                            key={category.id}
                                            active={String(value) === String(category.id)}
                                            onClick={() => handleCategorySelect(category.id)}
                                        >
                                            {category.name} (ID: {category.id})
                                        </Dropdown.Item>
                                    ))}
                                </>
                            )}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
                {error && (
                    <div className="invalid-feedback">
                        {error}
                    </div>
                )}
            </Col>
        </Form.Group>
    );
};

export default CategorySelect;

